/* The Katha: wishlist. A heart on cards and product pages ([data-kw="handle"]) keeps the product in this
   browser (localStorage 'kw'). Signed-in customers also keep it in atelier (rpc wish_get / wish_save, signed
   "wish|email|time" with the Circle key by the header: [data-kw-me]) so the list follows them to another
   device; without those functions it stays local. /pages/wishlist ([data-kw-page]) draws the cards from
   /products/<handle>.js and can share the list as /pages/wishlist?h=a,b,c. Texts: JSON in [data-kw-text]. */
(function () {
  if (window.KhWish) return;
  var KEY = 'kw', SNAP = 'kw_s', MAX = 60;
  var API = 'https://tpuzlucjbggmpajctkrx.supabase.co/rest/v1/rpc/';
  var APIKEY = 'sb_publishable_mEVoIbDuIJtqfa1SpwJjQQ_MXrIuvy1';
  var T = { add: 'save to wishlist', remove: 'remove from wishlist', saved: 'saved to your wishlist', removed: 'removed from your wishlist', see: 'see wishlist' };
  var tx = document.querySelector('[data-kw-text]');
  try { if (tx) { var o = JSON.parse(tx.textContent); for (var k in o) T[k] = o[k]; } } catch (e) {}
  var URL_PAGE = (tx && tx.getAttribute('data-url')) || '/pages/wishlist';

  function get(k) { try { var a = JSON.parse(localStorage.getItem(k) || 'null'); return Array.isArray(a) ? a.filter(ok) : null; } catch (e) { return null; } }
  function put(k, a) { try { localStorage.setItem(k, JSON.stringify(a)); } catch (e) {} }
  function ok(h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,120}$/.test(h); }
  var list = get(KEY) || [];
  var subs = [];
  function has(h) { return list.indexOf(h) > -1; }

  /* ── signed-in sync ── */
  var me = document.querySelector('[data-kw-me]');
  var signed = me && me.dataset.email && me.dataset.sig ? { p_email: me.dataset.email, p_ts: +me.dataset.ts, p_sig: me.dataset.sig } : null;
  function rpc(fn, extra) {
    var body = {}; for (var a in signed) body[a] = signed[a]; for (var b in extra || {}) body[b] = extra[b];
    return fetch(API + fn, { method: 'POST', headers: { 'Content-Type': 'application/json', apikey: APIKEY }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  var saveTimer = null;
  function pushSoon() {
    if (!signed) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      rpc('wish_save', { p_handles: list }).then(function (d) { if (d && d.ok) put(SNAP, list.slice()); });
    }, 500);
  }
  /* three-way merge: the last list both sides agreed on (SNAP) tells a removal elsewhere from an addition here */
  function merge(server) {
    var snap = get(SNAP) || [], out = [];
    list.forEach(function (h) { if (server.indexOf(h) > -1 || snap.indexOf(h) < 0) out.push(h); });
    server.forEach(function (h) { if (out.indexOf(h) < 0 && (list.indexOf(h) > -1 || snap.indexOf(h) < 0)) out.push(h); });
    return out.slice(0, MAX);
  }
  if (signed) {
    rpc('wish_get').then(function (d) {
      if (!d || !d.ok || !Array.isArray(d.handles)) return;
      var server = d.handles.filter(ok), next = merge(server);
      var changed = next.join() !== list.join();
      list = next; put(KEY, list);
      if (next.join() !== server.join()) pushSoon(); else put(SNAP, list.slice());
      if (changed) emit();
    });
  }

  /* ── hearts, header count, toast ── */
  function paint(root) {
    (root || document).querySelectorAll('[data-kw]').forEach(function (b) {
      var on = has(b.getAttribute('data-kw'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var nm = b.getAttribute('data-kw-title') || '';
      b.setAttribute('aria-label', (on ? T.remove : T.add) + (nm ? ': ' + nm : ''));
      b.dataset.kwP = '1';
    });
    document.querySelectorAll('[data-kw-count]').forEach(function (c) { c.textContent = list.length ? String(list.length) : ''; c.hidden = !list.length; });
  }
  function emit() { paint(); subs.forEach(function (f) { try { f(list.slice()); } catch (e) {} }); }
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'kw-toast'; toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (location.pathname.indexOf(URL_PAGE) !== 0) { var a = document.createElement('a'); a.href = URL_PAGE; a.textContent = T.see; toastEl.appendChild(a); }
    toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function toggle(h, quiet) {
    if (!ok(h)) return;
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else { list.unshift(h); if (list.length > MAX) list.length = MAX; }
    put(KEY, list); pushSoon(); emit();
    if (!quiet) toast(i > -1 ? T.removed : T.saved);
    try { if (i < 0 && window.dataLayer) window.dataLayer.push({ event: 'add_to_wishlist', item_id: h }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kw]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-kw'));
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { list = get(KEY) || []; emit(); } });

  /* cards added later (load more, search, recommendations) */
  var raf = 0;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; if (document.querySelector('[data-kw]:not([data-kw-p])')) paint(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.KhWish = {
    list: function () { return list.slice(); }, has: has, toggle: toggle,
    set: function (a) { list = a.filter(ok).slice(0, MAX); put(KEY, list); pushSoon(); emit(); },
    on: function (f) { subs.push(f); }, signedIn: !!signed
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); }); else paint();
})();
